import { createSlice } from "@reduxjs/toolkit";
import { PiApproximateEqualsBold } from "react-icons/pi";

const FilterTableSlice = createSlice({
  name: "filterTable",
  initialState: {
    filterTable: [],
    filterTableExcel: [],
  },

  reducers: {
    setFilterTable(state, action) {
      state.filterTable = action.payload || [];
    },
    setFilterTableExcel(state, action) {
      state.filterTableExcel = action.payload || [];
    },
    // addFilterTableItem(state, action) {
    //   const item = action.payload;
    //   const existingItemIndex = state.filterTable.findIndex(
    //     (i) => i.customRow === item.customRow && i.customRow != "Custom"
    //   );

    //   if (existingItemIndex !== -1) {
    //     if (item.customRow === "Custom") {
    //       const regex = /\d+|\+|\(|\)|\-|\*|\//g;
    //       const matches = item.headerName.match(regex);
    //       if (matches) {
    //         const criteriaArray = matches.map((match) => {
    //           if (!isNaN(match)) {
    //             const index = parseInt(match.trim(), 10) - 1;
    //             const existingItem = state.filterTable[index];
    //             return existingItem ? `(${existingItem.SFieldName})` : `(${match})`;
    //           }
    //           return `(${match})`;
    //         });
    //         const newScreenerQuery = criteriaArray.join(" ");
    //         let or, prox;
    //         let newScreenerQuery2 =
    //           newScreenerQuery +
    //           "|" +
    //           item.period +
    //           "|" +
    //           (or = "") +
    //           "|" +
    //           (prox = "") +
    //           "| " +
    //           item.criteria +
    //           "|" +
    //           item.radioButton +
    //           "|" +
    //           item.DisplayName.replace(/'/g, "") +
    //           "¤";

    //         state.filterTable.push(item);
    //         return;
    //       }
    //     }
    //     state.filterTable.push(item);
    //   } else {
    //     if (item.customRow == "Custom") {
    //       const regex = /\d+|\+|\(|\)|\-|\*|\//g;
    //       const matches = item.headerName.match(regex);
    //       if (matches) {
    //         const criteriaArray = matches.map((match) => {
    //           if (!isNaN(match)) {
    //             const index = parseInt(match.trim(), 10) - 1;
    //             const existingItem = state.filterTable[index];

    //             if (existingItem) {
    //               if (item.radioButton === "C") {
    //                 return `(${existingItem.CFieldName})`;
    //               } else if (item.radioButton === "CP") {
    //                 return `(${existingItem.CFieldName})~(${existingItem.SFieldName})`;
    //               } else {
    //                 return existingItem.SFieldName;
    //               }
    //             }

    //             return match;
    //           }
    //           return match;
    //         });
    //         const newScreenerQuery = criteriaArray.join("");
    //         let or, prox;

    //         let newScreenerQuery2 =
    //           newScreenerQuery +
    //           "|" +
    //           item.period +
    //           "|" +
    //           (or = "") +
    //           "|" +
    //           (prox = "") +
    //           "| " +
    //           item.criteria +
    //           "|" +
    //           item.radioButton +
    //           "|" +
    //           item.DisplayName.replace(/'/g, "") +
    //           "¤";
    //         state.filterTable.push({
    //           ...item,
    //           screenerQuery: newScreenerQuery2,
    //           updateDisplayName: item.DisplayName,
    //         });
    //         return;
    //       }
    //     }
    //     state.filterTable.push(item);
    //   }
    // },

    // addFilterTableItem(state, action) {
    //   // edited by prathamesh
    //   const item = action.payload;
    //   const buildScreenerQuery = () => {
    //     const regex = /\[\d+\]|\d+|\+|\(|\)|\-|\*|\//g;
    //     const matches = item.headerName.match(regex);

    //     if (!matches) return null;

    //     const criteriaArray = matches.map((match) => {
    //       const squareBracketMatch = match.match(/\[(\d+)\]/);
    //       if (squareBracketMatch) {
    //         return squareBracketMatch[1];
    //       }
    //       if (!isNaN(match)) {
    //         const index = parseInt(match.trim(), 10) - 1;
    //         const existingItem = state.filterTable[index];

    //         if (existingItem) {
    //           if (item.radioButton === "C") {
    //             return `(${existingItem.CFieldName})`;
    //           } else if (item.radioButton === "CP") {
    //             return `(${existingItem.CFieldName})~(${existingItem.SFieldName})`;
    //           } else {
    //             return `(${existingItem.SFieldName})`;
    //           }
    //         }

    //         return `(${match})`;
    //       }
    //       return match;
    //     });

    //     return criteriaArray.join(" ");
    //   };

    //   if (item.customRow === "Custom") {
    //     const newScreenerQuery = buildScreenerQuery();
    //     if (newScreenerQuery) {
    //       const or = "";
    //       const prox = "";

    //       const newScreenerQuery2 =
    //         newScreenerQuery +
    //         "|" +
    //         item.period +
    //         "|" +
    //         or +
    //         "|" +
    //         prox +
    //         "| " +
    //         item.criteria +
    //         "|" +
    //         item.radioButton +
    //         "|" +
    //         item.DisplayName.replace(/'/g, "") +
    //         "¤";

    //       state.filterTable.push({
    //         ...item,
    //         screenerQuery: newScreenerQuery2,
    //         updateDisplayName: item.DisplayName,
    //       });
    //       return;
    //     }
    //   }
    //   state.filterTable.push(item);
    // },

    // addFilterTableItem(state, action) {
    //   // edited by prathamesh
    //   const item = action.payload;
    //   const buildScreenerQuery = () => {
    //     const cleanHeaderName = item.headerName.replace(/\s+/g, "");
    //     const regex = /\[\d+(\.\d+)?\]|\d+(\.\d+)?|[()+\-*/]/g;
    //     const matches = cleanHeaderName.match(regex);

    //     if (!matches) return null;

    //     const criteriaArray = matches.map((match) => {
    //       const squareBracketMatch = match.match(/^\[(\d+(\.\d+)?)\]$/);
    //       if (squareBracketMatch) {
    //         return squareBracketMatch[1];
    //       }
    //       if (!isNaN(match)) {
    //         const index = parseInt(match, 10) - 1;
    //         const existingItem = state.filterTable[index];

    //         if (existingItem) {
    //           if (item.radioButton === "C") {
    //             return `${existingItem.CFieldName}`;
    //           } else if (item.radioButton === "CP") {
    //             return `${existingItem.CFieldName}~${existingItem.SFieldName}`;
    //           } else {
    //             return `${existingItem.SFieldName}`;
    //           }
    //         }
    //         return match;
    //       }

    //       return match;
    //     });

    //     return criteriaArray.join("");
    //   };

    //   if (item.customRow === "Custom") {
    //     const newScreenerQuery = buildScreenerQuery();
    //     if (newScreenerQuery) {
    //       const or = "";
    //       const prox = "";

    //       const newScreenerQuery2 =
    //         `${newScreenerQuery}` +
    //         "|" +
    //         item.period +
    //         "|" +
    //         or +
    //         "|" +
    //         prox +
    //         "| " +
    //         item.criteria +
    //         "|" +
    //         item.radioButton +
    //         "|" +
    //         item.DisplayName.replace(/'/g, "") +
    //         "¤";

    //       state.filterTable.push({
    //         ...item,
    //         screenerQuery: newScreenerQuery2,
    //         updateDisplayName: item.DisplayName,
    //       });
    //       return;
    //     }
    //   }
    //   state.filterTable.push(item);
    // },

    addFilterTableItem(state, action) {
      // edited by prathamesh
      const item = action.payload;

      const existingIndex = state.filterTable.findIndex(
        (row) => row.uniqueId === item.uniqueId
      );
      const buildScreenerQuery = () => {
        const cleanHeaderName = item.headerName.replace(/\s+/g, "");
        const regex = /\[\d+(\.\d+)?\]|\d+(\.\d+)?|[()+\-*/]/g;
        const matches = cleanHeaderName.match(regex);

        if (!matches) return null;

        const criteriaArray = matches.map((match) => {
          const squareBracketMatch = match.match(/^\[(\d+(\.\d+)?)\]$/);
          if (squareBracketMatch) {
            return squareBracketMatch[1];
          }
          if (!isNaN(match)) {
            const index = parseInt(match, 10) - 1;
            const existingItem = state.filterTable[index];

            if (existingItem) {
              if (item.radioButton === "C") {
                return `${existingItem.CFieldName}`;
              } else if (item.radioButton === "CP") {
                return `${existingItem.CFieldName}~${existingItem.SFieldName}`;
              } else {
                return `${existingItem.SFieldName}`;
              }
            }
            return match;
          }

          return match;
        });

        return criteriaArray.join("");
      };

      if (item.customRow === "Custom") {
        const newScreenerQuery = buildScreenerQuery();
        if (newScreenerQuery) {
          const or = "";
          const prox = "";

          const newScreenerQuery2 =
            `${newScreenerQuery}` +
            "|" +
            item.period +
            "|" +
            or +
            "|" +
            prox +
            "| " +
            item.criteria +
            "|" +
            item.radioButton +
            "|" +
            item.DisplayName.replace(/'/g, "") +
            "¤";


          const updatedItem = {
            ...item,
            screenerQuery: newScreenerQuery2,
            updateDisplayName: item.DisplayName,
          };


          if (existingIndex !== -1) {

            state.filterTable[existingIndex] = updatedItem;
          } else {

            state.filterTable.push(updatedItem);
          }


          // state.filterTable.push({
          //   ...item,
          //   screenerQuery: newScreenerQuery2,
          //   updateDisplayName: item.DisplayName,
          // });
          return;
        }
      }
      state.filterTable.push(item);
    },


    updateFilterChechboxName(state, action) {
      const data = { ...action.payload };
      const existingItemIndex = state.filterTable.findIndex(
        (item) => item.uniqueId === data.uniqueId
      );

      if (existingItemIndex !== -1) {
        state.filterTable = state.filterTable.map((item) =>
          item.uniqueId === data.uniqueId
            ? {
              ...item,
              isFilterCheckboxSelect: data.isFilterCheckboxSelect,

            }
            : item
        );
      }

    },

    updateCustomDisplayName(state, action) {
      const data = { ...action.payload };

      const existingItemIndex = state.filterTable.findIndex(
        (item) => item.uniqueId === data.uniqueId
      );

      if (existingItemIndex !== -1) {
        state.filterTable = state.filterTable.map((item) =>
          item.uniqueId === data.uniqueId
            ? {
              ...item,
              DisplayName: data.DisplayName.replace(/'/g, ""),
              updateDisplayName: data.updateDisplayName.replace(/'/g, ""),
            }
            : item
        );
      }
    },

    updatePopupCriteria(state, action) {
      const {
        criteraiData,
        newCriteria,
        newScreenerQuery,
        oprtr,
        inp1,
        inp2,
        relLogOprt,
        relTextSel,
        relArithOprtr,
      } = action.payload;
      const exstingItemIndex = state.filterTable.findIndex(
        (item) => item.uniqueId === criteraiData.uniqueId
      );

      if (exstingItemIndex !== -1) {
        state.filterTable = state.filterTable.map((item) =>
          item.uniqueId === criteraiData.uniqueId
            ? {
              ...item,
              criteria: newCriteria,
              screenerQuery: newScreenerQuery,
              oprtr: oprtr,
              inp1: inp1,
              inp2: inp2,
              relLogOprt: relLogOprt,
              relTextSel: relTextSel,
              relArithOprtr: relArithOprtr,
            }
            : item
        );
      }
    },

    handleCancelCriteria(state, action) {
      const {
        criteraiData,
        newCriteria,
        newScreenerQuery,
        oprtr,
        inp1,
        inp2,
        relLogOprt,
        relTextSel,
        relArithOprtr,
      } = action.payload;
      const exstingItemIndex = state.filterTable.findIndex(
        (item) => item.uniqueId === criteraiData.uniqueId
      );

      if (exstingItemIndex !== -1) {
        state.filterTable = state.filterTable.map((item) =>
          item.uniqueId === criteraiData.uniqueId
            ? {
              ...item,
              criteria: newCriteria,
              screenerQuery: newScreenerQuery,
              oprtr: oprtr,
              inp1: inp1,
              inp2: inp2,
              relLogOprt: relLogOprt,
              relTextSel: relTextSel,
              relArithOprtr: relArithOprtr,
            }
            : item
        );
      }
    },

    clearFilterTable(state) {
      state.filterTable = [];
    },
    removeFilterTableItem(state, action) {
      const itemId = action.payload;

      state.filterTable = state.filterTable
        .flat()
        .filter((item) => item.uniqueId !== itemId);
    },

    updateFilterTableItem(state, action) {
      const { id, newValue, all, existingData, radiobutton, Displayname } =
        action.payload;
      let or, prox;
      let newScreenerQuery;
      if (radiobutton === "C") {
        if (existingData.CFieldName == null) {
          newScreenerQuery =
            existingData.SFieldName +
            "|" +
            newValue +
            "|" +
            (or = "") +
            "|" +
            (prox = "") +
            "| " +
            existingData.criteria +
            "|" +
            radiobutton +
            "|" +
            Displayname.replace(/'/g, "") +
            "¤";
        } else {
          newScreenerQuery =
            existingData.CFieldName +
            "|" +
            newValue +
            "|" +
            (or = "") +
            "|" +
            (prox = "") +
            "| " +
            existingData.criteria +
            "|" +
            radiobutton +
            "|" +
            Displayname.replace(/'/g, "") +
            "¤";
        }
      } else if (radiobutton === "CP") {
        newScreenerQuery =
          `${existingData.CFieldName}~${existingData.SFieldName}` +
          "|" +
          newValue +
          "|" +
          (or = "") +
          "|" +
          (prox = "") +
          "| " +
          existingData.criteria +
          "|" +
          radiobutton +
          "|" +
          Displayname.replace(/'/g, "") +
          "¤";
      } else {
        newScreenerQuery =
          existingData.SFieldName +
          "|" +
          newValue +
          "|" +
          (or = "") +
          "|" +
          (prox = "") +
          "| " +
          existingData.criteria +
          "|" +
          radiobutton +
          "|" +
          Displayname.replace(/'/g, "") +
          "¤";
      }

      // if (all) {
      //   return {
      //     ...state,
      //     filterTable: state.filterTable.map((item) => {
      //       if (radiobutton === "C") {
      //         if (existingData.CFieldName == null) {
      //           newScreenerQuery =
      //             existingData.SFieldName +
      //             "|" +
      //             newValue +
      //             "|" +
      //             (or = "") +
      //             "|" +
      //             (prox = "") +
      //             "| " +
      //             existingData.criteria +
      //             "|" +
      //             radiobutton +
      //             "|" +
      //             Displayname.replace(/'/g, "") +
      //             "¤";
      //         } else {
      //           newScreenerQuery =
      //             existingData.CFieldName +
      //             "|" +
      //             newValue +
      //             "|" +
      //             (or = "") +
      //             "|" +
      //             (prox = "") +
      //             "| " +
      //             existingData.criteria +
      //             "|" +
      //             radiobutton +
      //             "|" +
      //             Displayname.replace(/'/g, "") +
      //             "¤";
      //         }
      //       } else if (radiobutton === "CP") {
      //         newScreenerQuery =
      //           `${existingData.CFieldName}~${existingData.SFieldName}` +
      //           "|" +
      //           newValue +
      //           "|" +
      //           (or = "") +
      //           "|" +
      //           (prox = "") +
      //           "| " +
      //           existingData.criteria +
      //           "|" +
      //           radiobutton +
      //           "|" +
      //           Displayname.replace(/'/g, "") +
      //           "¤";
      //       } else {
      //         newScreenerQuery =
      //           existingData.SFieldName +
      //           "|" +
      //           newValue +
      //           "|" +
      //           (or = "") +
      //           "|" +
      //           (prox = "") +
      //           "| " +
      //           existingData.criteria +
      //           "|" +
      //           radiobutton +
      //           "|" +
      //           Displayname.replace(/'/g, "") +
      //           "¤";
      //       }

      //       if (item.customRow === "Custom") {
      //         let exstingCriteria = item.screenerQuery;
      //         const regex = /\bL[0-8]?\b/g;
      //         let updatedCriteria = exstingCriteria.replace(regex, newValue);
      //         return {
      //           ...item,
      //           period: newValue,
      //           screenerQuery: updatedCriteria,
      //         };
      //       }

      //       return {
      //         ...item,
      //         period: newValue,
      //         screenerQuery: newScreenerQuery,
      //       };
      //     }),
      //   };
      // }

      if (all) {
        return {
          ...state,
          filterTable: state.filterTable.map((item) => {
            let or = "";
            let prox = "";
            let newScreenerQuery;

            if (radiobutton === "C") {
              if (item.CFieldName == null) {
                newScreenerQuery =
                  item.SFieldName +
                  "|" +
                  newValue +
                  "|" +
                  or +
                  "|" +
                  prox +
                  "| " +
                  item.criteria +
                  "|" +
                  radiobutton +
                  "|" +
                  item.DisplayName.replace(/'/g, "") +
                  "¤";
              } else {
                newScreenerQuery =
                  item.CFieldName +
                  "|" +
                  newValue +
                  "|" +
                  or +
                  "|" +
                  prox +
                  "| " +
                  item.criteria +
                  "|" +
                  radiobutton +
                  "|" +
                  item.DisplayName.replace(/'/g, "") +
                  "¤";
              }
            } else if (radiobutton === "CP") {
              newScreenerQuery =
                `${item.CFieldName}~${item.SFieldName}` +
                "|" +
                newValue +
                "|" +
                or +
                "|" +
                prox +
                "| " +
                item.criteria +
                "|" +
                radiobutton +
                "|" +
                item.DisplayName.replace(/'/g, "") +
                "¤";
            } else {
              newScreenerQuery =
                item.SFieldName +
                "|" +
                newValue +
                "|" +
                or +
                "|" +
                prox +
                "| " +
                item.criteria +
                "|" +
                radiobutton +
                "|" +
                item.DisplayName.replace(/'/g, "") +
                "¤";
            }

            if (item.customRow === "Custom") {
              let exstingCriteria = item.screenerQuery;
              const regex = /\bL[0-8]?\b/g;
              let updatedCriteria = exstingCriteria.replace(regex, newValue);

              return {
                ...item,
                period: newValue,
                screenerQuery: updatedCriteria,
              };
            }

            return {
              ...item,
              period: newValue,
              screenerQuery: newScreenerQuery,
            };
          }),
        };
      }

      const item = state.filterTable.find((item) => item.uniqueId === id);

      if (item) {
        if (item.customRow === "Custom") {
          let exstingCriteria = item.screenerQuery;
          const regex = /\bL[0-8]?\b|\| *\|/;

          let updatedCriteria = exstingCriteria.replace(regex, (match) => {
            if (match.trim() === "||") {
              return `|${newValue}|`;
            }
            return match === "L" || match.match(/^L[0-8]?$/) ? newValue : match;
          });
          return {
            ...state,
            filterTable: state.filterTable.map((item) =>
              item.uniqueId === id
                ? { ...item, period: newValue, screenerQuery: updatedCriteria }
                : item
            ),
          };
        }
        return {
          ...state,
          filterTable: state.filterTable.map((item) =>
            item.uniqueId === id
              ? { ...item, period: newValue, screenerQuery: newScreenerQuery }
              : item
          ),
        };
      }
    },

    updateApiFilterTableItem(state, action) {
      const { id, newValue, all, existingData, radiobutton, Displayname } =
        action.payload;
      const yearLimit = action.payload?.years ?? action.payload?.year ?? action.payload?.yearCount ?? action.payload?.yearsLimit ?? 5;
      const currentYear = new Date().getFullYear();
      let or, prox;
      let newScreenerQuery;
      if (radiobutton === "C") {
        if (existingData.CFieldName == null) {
          newScreenerQuery =
            existingData.SFieldName +
            "|" +
            newValue +
            "|" +
            (or = "") +
            "|" +
            (prox = "") +
            "| " +
            existingData.criteria +
            "|" +
            radiobutton +
            "|" +
            Displayname.replace(/'/g, "") +
            "¤";
        } else {
          newScreenerQuery =
            existingData.CFieldName +
            "|" +
            newValue +
            "|" +
            (or = "") +
            "|" +
            (prox = "") +
            "| " +
            existingData.criteria +
            "|" +
            radiobutton +
            "|" +
            Displayname.replace(/'/g, "") +
            "¤";
        }
      } else if (radiobutton === "CP") {
        newScreenerQuery =
          `${existingData.CFieldName}~${existingData.SFieldName}` +
          "|" +
          newValue +
          "|" +
          (or = "") +
          "|" +
          (prox = "") +
          "| " +
          existingData.criteria +
          "|" +
          radiobutton +
          "|" +
          Displayname.replace(/'/g, "") +
          "¤";
      } else {
        newScreenerQuery =
          existingData.SFieldName +
          "|" +
          newValue +
          "|" +
          (or = "") +
          "|" +
          (prox = "") +
          "| " +
          existingData.criteria +
          "|" +
          radiobutton +
          "|" +
          Displayname.replace(/'/g, "") +
          "¤";
      }

      if (all) {
        return {
          ...state,
          filterTable: state.filterTable.map((item) => {
            if (radiobutton === "C") {
              if (existingData.CFieldName == null) {
                newScreenerQuery =
                  existingData.SFieldName +
                    "|" +
                    newValue +
                    "|" +
                    (or = "") +
                    "|" +
                    (prox = "") +
                    "| " +
                    Displayname ===
                    "Year End"
                    ? item.criteria === "" ? `> ${currentYear - (yearLimit - 1)}01` : item.criteria
                    : existingData.criteria +
                    "|" +
                    radiobutton +
                    "|" +
                    Displayname.replace(/'/g, "") +
                    "¤";
              } else {
                newScreenerQuery =
                  existingData.CFieldName +
                    "|" +
                    newValue +
                    "|" +
                    (or = "") +
                    "|" +
                    (prox = "") +
                    "| " +
                    Displayname ===
                    "Year End"
                    ? item.criteria === "" ? `> ${currentYear - (yearLimit - 1)}01` : item.criteria
                    : existingData.criteria +
                    "|" +
                    radiobutton +
                    "|" +
                    Displayname.replace(/'/g, "") +
                    "¤";
              }
            } else if (radiobutton === "CP") {
              newScreenerQuery =
                `${existingData.CFieldName}~${existingData.SFieldName}` +
                  "|" +
                  newValue +
                  "|" +
                  (or = "") +
                  "|" +
                  (prox = "") +
                  "| " +
                  Displayname ===
                  "Year End"
                  ? item.criteria === "" ? `> ${currentYear - (yearLimit - 1)}01` : item.criteria
                  : existingData.criteria +
                  "|" +
                  radiobutton +
                  "|" +
                  Displayname.replace(/'/g, "") +
                  "¤";
            } else {
              newScreenerQuery =
                existingData.SFieldName +
                  "|" +
                  newValue +
                  "|" +
                  (or = "") +
                  "|" +
                  (prox = "") +
                  "| " +
                  Displayname ===
                  "Year End"
                  ? item.criteria === "" ? `> ${currentYear - (yearLimit - 1)}01` : item.criteria
                  : existingData.criteria +
                  "|" +
                  radiobutton +
                  "|" +
                  Displayname.replace(/'/g, "") +
                  "¤";
            }

            if (item.customRow === "Custom") {
              let exstingCriteria = item.screenerQuery;
              const regex = /\bL[0-8]?\b/g;
              let updatedCriteria = exstingCriteria.replace(regex, newValue);
              return {
                ...item,
                period: newValue,
                screenerQuery: updatedCriteria,
              };
            }

            return {
              ...item,
              period: newValue,
              screenerQuery: newScreenerQuery,
            };
          }),
        };
      }

      const item = state.filterTable.find((item) => item.uniqueId === id);

      if (item) {
        if (item.customRow === "Custom") {
          let exstingCriteria = item.screenerQuery;
          const regex = /\bL[0-8]?\b|\| *\|/;

          let updatedCriteria = exstingCriteria.replace(regex, (match) => {
            if (match.trim() === "||") {
              return `|${newValue}|`;
            }
            return match === "L" || match.match(/^L[0-8]?$/) ? newValue : match;
          });
          return {
            ...state,
            filterTable: state.filterTable.map((item) =>
              item.uniqueId === id
                ? { ...item, period: newValue, screenerQuery: updatedCriteria }
                : item
            ),
          };
        }
        return {
          ...state,
          filterTable: state.filterTable.map((item) =>
            item.uniqueId === id
              ? { ...item, period: newValue, screenerQuery: newScreenerQuery }
              : item
          ),
        };
      }
    },

    updateAscDescDropdown(state, action) {
      const { id, or } = action.payload;
      const exstingItemIndex = state.filterTable.findIndex(
        (item) => item.uniqueId === id
      );

      if (exstingItemIndex !== -1) {
        state.filterTable = state.filterTable.map((item) =>
          item.uniqueId === id
            ? {
              ...item,
              or: or,
            }
            : item
        );
      }
    },

    updateReturnsDay(state, action) {
      const { id, proxN, proxS, customDate } = action.payload;
      const existingItemIndex = state.filterTable.findIndex(
        (item) => item.uniqueId === id
      );

      if (existingItemIndex !== -1) {
        state.filterTable = state.filterTable.map((item) =>
          item.uniqueId === id
            ? { ...item, proxN: proxN, proxS: proxS, customDate: customDate }
            : item
        );
      }
    },

    // updateCriteriaOnClickRadio: (state, action) => {
    //   const { reduxRadioButton, saveFilterData } = action.payload;

    //   saveFilterData.forEach((item) => {
    //     let newScreener;
    //     // let or = "";
    //     let prox = "";

    //     if (reduxRadioButton === "C") {
    //       if (item.customRow === "Custom") {
    //         const regex = /\d+|\+|\(|\)|\-|\*|\//g;
    //         const matches = item.headerName.match(regex);
    //         if (matches) {
    //           const criteriaArray = matches.map((match) => {
    //             if (!isNaN(match)) {
    //               const index = parseInt(match.trim(), 10) - 1;
    //               const existingItem = state.filterTable[index];
    //               return existingItem && existingItem.CFieldName !== null
    //                 ? existingItem.CFieldName
    //                 : existingItem
    //                   ? existingItem.SFieldName
    //                   : match;
    //             }
    //             return match;
    //           });
    //           const newScreenerQuery = criteriaArray.join(" ");
    //           newScreener = `${newScreenerQuery}|${item.period}|${item.or}|${prox}|${item.criteria
    //             }|${reduxRadioButton}|${item.DisplayName.replace(/'/g, "")}¤`;
    //         }
    //       } else {
    //         if (item.CFieldName == null) {
    //           newScreener = `${item.SFieldName}|${item.period}|${item.or}|${prox}|${item.criteria
    //             }|${reduxRadioButton}|${item.DisplayName.replace(/'/g, "")}¤`;
    //         } else {
    //           newScreener = `${item.CFieldName}|${item.period}|${item.or}|${prox}|${item.criteria
    //             }|${reduxRadioButton}|${item.DisplayName.replace(/'/g, "")}¤`;
    //         }
    //       }
    //     } else if (reduxRadioButton === "CP") {
    //       if (item.customRow === "Custom") {
    //         const regex = /\d+|\+|\(|\)|\-|\*|\//g;
    //         const matches = item.headerName.match(regex);
    //         if (matches) {
    //           const criteriaArray = matches.map((match) => {
    //             if (!isNaN(match)) {
    //               const index = parseInt(match.trim(), 10) - 1;
    //               const existingItem = state.filterTable[index];
    //               return existingItem
    //                 ? `${existingItem.CFieldName || existingItem.SFieldName}~${existingItem.SFieldName
    //                 }`
    //                 : match;
    //             }
    //             return match;
    //           });
    //           const newScreenerQuery = criteriaArray.join(" ");
    //           newScreener = `${newScreenerQuery}|${item.period}|${item.or}|${prox}|${item.criteria
    //             }|${reduxRadioButton}|${item.DisplayName.replace(/'/g, "")}¤`;
    //         }
    //       } else {
    //         newScreener = `${item.CFieldName || item.SFieldName}~${item.SFieldName
    //           }|${item.period}|${item.or}|${prox}|${item.criteria
    //           }|${reduxRadioButton}|${item.DisplayName.replace(/'/g, "")}¤`;
    //       }
    //     } else {
    //       if (item.customRow === "Custom") {
    //         const regex = /\d+|\+|\(|\)|\-|\*|\//g;
    //         const matches = item.headerName.match(regex);
    //         if (matches) {
    //           const criteriaArray = matches.map((match) => {
    //             if (!isNaN(match)) {
    //               const index = parseInt(match.trim(), 10) - 1;
    //               const existingItem = state.filterTable[index];
    //               return existingItem ? existingItem.SFieldName : match;
    updateCriteriaOnClickRadio: (state, action) => {
      const { reduxRadioButton, saveFilterData, isSelectedCompanies2 } = action.payload;
      const currentYear = new Date().getFullYear();
      saveFilterData.forEach((item) => {
        let newScreener;
        let prox = "";

        const buildCriteriaArray = () => {
          const cleanHeaderName = item.headerName.replace(/\s+/g, "");
          const regex = /\[\d+(\.\d+)?\]|\d+(\.\d+)?|[\+\-\*\/\(\)]/g;
          const matches = cleanHeaderName.match(regex);
          if (!matches) return null;

          const criteriaArray = matches.map((match) => {
            const squareBracketMatch = match.match(/^\[(\d+(\.\d+)?)\]$/);
            if (squareBracketMatch) {
              return squareBracketMatch[1];
            }

            if (!isNaN(match)) {
              const index = parseInt(match.trim(), 10) - 1;
              const existingItem = state.filterTable[index];

              if (existingItem) {
                if (reduxRadioButton === "C") {
                  return `${existingItem.CFieldName || existingItem.SFieldName
                    }`;
                } else if (reduxRadioButton === "CP") {
                  return `${existingItem.CFieldName || existingItem.SFieldName
                    }~${existingItem.SFieldName}`;
                } else {
                  return `${existingItem.SFieldName}`;
                }
              }

              return match;
            }

            return match;
          });

          return criteriaArray.join("");
        };

        let formateReturnDate = (data) => {
          if (data == "") {
            return "";
          }
          let splitDate = data?.split("/");
          let month = splitDate[1];
          let day = splitDate[0];
          let year = splitDate[2];

          return `~${month}/${day}/${year}`;
        };

        let formateReturntoDate = (data) => {
          if (data == "") {
            return "";
          }
          let splitDate = data?.split("/");
          let month = splitDate[1];
          let day = splitDate[0];
          let year = splitDate[2];

          return `${month}/${day}/${year}`;
        };

        let customDateFormate =
          item?.customDate && formateReturnDate(item.customDate);

        let customReturnDate = customDateFormate && customDateFormate;

        let customToDateFormate =
          item?.proxN === "" && formateReturntoDate(item.proxS);

        let customReturnToDate = customToDateFormate && customToDateFormate;

        let crt =
          (item.header === "Stock Returns" || item.header === "Median")
            ? item?.proxN == "" ? `${customReturnToDate}${customReturnDate}` : `${item.proxN}${item.proxS}${customReturnDate}`
            : `${item.criteria}`;

        const crtValue = crt && crt.trim() !== "" ? crt.trim() : " ";

        if (item.customRow === "Custom") {
          const newScreenerQuery = buildCriteriaArray();
          if (newScreenerQuery) {
            newScreener = `${newScreenerQuery}|${item.period}|${item.or || ""
              }|${prox}|${crtValue
              }|${reduxRadioButton}|${item.DisplayName.replace(/'/g, "")}¤`;
          }
        } else {
          if (reduxRadioButton === "C") {
            newScreener = `${item.CFieldName || item.SFieldName}|${item.period
              }|${item.or || ""
              }|${prox}|${crtValue}|${reduxRadioButton}|${item.DisplayName.replace(
                /'/g,
                ""
              )}¤`;
          } else if (reduxRadioButton === "CP") {
            newScreener = `${item.CFieldName || item.SFieldName}~${item.SFieldName
              }|${item.period}|${item.or || ""
              }|${prox}|${crtValue}|${reduxRadioButton}|${item.DisplayName.replace(
                /'/g,
                ""
              )}¤`;
          } else {
            newScreener = `${item.SFieldName}|${item.period}|${item.or || ""
              }|${prox}|${crtValue}|${reduxRadioButton}|${item.DisplayName.replace(
                /'/g,
                ""
              )}¤`;
          }
        }

        const index = state.filterTable.findIndex(
          (tableItem) => tableItem.uniqueId === item.uniqueId
        );


        if (index !== -1) {
          state.filterTable[index] = {
            ...state.filterTable[index],
            screenerQuery: newScreener,
            radioButton: reduxRadioButton,
            isSelectedCheckBox: isSelectedCompanies2
          };
        } else {
          state.filterTable.push({
            ...item,
            screenerQuery: newScreener,
            radioButton: reduxRadioButton,
            isSelectedCheckBox: isSelectedCompanies2
          });
        }
      });
    },

    updateCriteriaOnClickRadioAPI: (state, action) => {
      // edited by prathamesh
      debugger
      const { reduxRadioButton, saveFilterData, isSelectedCompanies2 } = action.payload;
      const yearLimit = action.payload?.years ?? action.payload?.year ?? action.payload?.yearCount ?? action.payload?.yearsLimit ?? 5;
      const currentYear = new Date().getFullYear();

      const yearsAgo = new Date();
      yearsAgo.setFullYear(yearsAgo.getFullYear() - yearLimit);

      // Format as DD/MM/YYYY
      const formattedDate =
        ("0" + (yearsAgo.getMonth() + 1)).slice(-2) + "/" +
        ("0" + yearsAgo.getDate()).slice(-2) + "/" +
        yearsAgo.getFullYear();

      saveFilterData.forEach((item) => {
        let newScreener;
        let prox = "";

        const buildCriteriaArray = () => {
          const cleanHeaderName = item.headerName.replace(/\s+/g, "");
          const regex = /\[\d+(\.\d+)?\]|\d+(\.\d+)?|[\+\-\*\/\(\)]/g;
          const matches = cleanHeaderName.match(regex);

          if (!matches) return null;

          const criteriaArray = matches.map((match) => {
            const squareBracketMatch = match.match(/^\[(\d+(\.\d+)?)\]$/);
            if (squareBracketMatch) {
              return squareBracketMatch[1];
            }

            if (!isNaN(match)) {
              const index = parseInt(match.trim(), 10) - 1;
              const existingItem = state.filterTable[index];

              if (existingItem) {
                if (reduxRadioButton === "C") {
                  return `${existingItem.CFieldName || existingItem.SFieldName
                    }`;
                } else if (reduxRadioButton === "CP") {
                  return `${existingItem.CFieldName || existingItem.SFieldName
                    }~${existingItem.SFieldName}`;
                } else {
                  return `${existingItem.SFieldName}`;
                }
              }

              return match;
            }

            return match;
          });

          return criteriaArray.join("");
        };

        let formateReturnDate = (data) => {
          if (data == "") {
            return "";
          }
          let splitDate = data?.split("/");
          let month = splitDate[1];
          let day = splitDate[0];
          let year = splitDate[2];

          return `~${month}/${day}/${year}`;
        };

        let formateReturntoDate = (data) => {
          if (data == "") {
            return "";
          }
          let splitDate = data?.split("/");
          let month = splitDate[1];
          let day = splitDate[0];
          let year = splitDate[2];

          return `${month}/${day}/${year}`;
        };

        let customDateFormate =
          item?.customDate && formateReturnDate(item.customDate);

        let customReturnDate = customDateFormate && customDateFormate;

        let customToDateFormate =
          item?.proxN === "" && formateReturntoDate(item.proxS);

        let customReturnToDate = customToDateFormate && customToDateFormate;

        let crt =
          (item.header === "Stock Returns" || item.header === "Median")
            ? item?.proxN == "" ? `${customReturnToDate}${customReturnDate}` : `${item.proxN}${item.proxS}${customReturnDate}`
            : item.DisplayName === "Year End"
              ? `> ${currentYear - (yearLimit - 1)}01`
              : (item.DisplayName === "Source Date" || item.DisplayName === "Date")
                ? item.criteria === "" ? `> '${formattedDate}'` : item.criteria
                : item.criteria;

        const crtValue = crt && crt.trim() !== "" ? crt.trim() : " ";

        if (item.customRow === "Custom") {
          const newScreenerQuery = buildCriteriaArray();
          if (newScreenerQuery) {
            newScreener = `${newScreenerQuery}|${item.period}|${item.or || ""
              }|${prox}|${crtValue
              }|${reduxRadioButton}|${item.DisplayName.replace(/'/g, "")}¤`;
          }
        } else {
          if (reduxRadioButton === "C") {
            newScreener = `${item.CFieldName || item.SFieldName}|${item.period
              }|${item.or || ""}|${prox}|${crtValue}|${reduxRadioButton}|${item.DisplayName.replace(/'/g, "")}¤`;
          } else if (reduxRadioButton === "CP") {
            newScreener = `${item.CFieldName || item.SFieldName}~${item.SFieldName
              }|${item.period}|${item.or || ""}|${prox}|${crtValue}|${reduxRadioButton}|${item.DisplayName.replace(/'/g, "")}¤`;
          } else {
            newScreener = `${item.SFieldName}|${item.period}|${item.or || ""
              }|${prox}|${crtValue}|${reduxRadioButton}|${item.DisplayName.replace(/'/g, "")}¤`;
          }
        }

        const index = state.filterTable.findIndex(
          (tableItem) => tableItem.uniqueId === item.uniqueId
        );

        if (index !== -1) {
          state.filterTable[index] = {
            ...state.filterTable[index],
            screenerQuery: newScreener,
            radioButton: reduxRadioButton,
            isSelectedCheckBox: isSelectedCompanies2
          };
        } else {
          state.filterTable.push({
            ...item,
            screenerQuery: newScreener,
            radioButton: reduxRadioButton,
            isSelectedCheckBox: isSelectedCompanies2
          });
        }
      });
    },
    criteriaModelonSave: (state, action) => {
      const { uniqueId, criteria, elements } = action.payload;

      const index = state.filterTable.findIndex(
        (item) => item.uniqueId === uniqueId
      );

      if (index !== -1) {
        state.filterTable = state.filterTable.map((item) => {
          if (item.uniqueId === uniqueId) {
            const crtValue = criteria && criteria.trim() !== "" ? criteria.trim() : " ";
            const field =
              item.radioButton === "C"
                ? (item.CFieldName || item.SFieldName)
                : item.radioButton === "CP"
                ? `${item.CFieldName || item.SFieldName}~${item.SFieldName}`
                : item.SFieldName;
            const updatedScreenerQuery = item.customRow === "Custom"
              ? item.screenerQuery
              : `${field}|${item.period || ""}|${item.or || ""}|${item.prox || ""}|${crtValue}|${item.radioButton || "S"}|${(item.DisplayName || "").replace(/'/g, "")}¤`;

            return {
              ...item,
              criteria: criteria,
              inp: elements,
              screenerQuery: updatedScreenerQuery,
            };
          }
          return item;
        });
      }
    },

    handleradioButton: (state, action) => {
      const { uniqueId, id, value } = action.payload;
      const index = state.filterTable.findIndex(
        (item) => item.uniqueId === uniqueId
      );

      if (index !== -1) {
        const element = state.filterTable[index];

        const inpIndex = element.inp.findIndex((item) => item.id === id);

        if (inpIndex !== -1) {
          element.inp[inpIndex] = {
            ...element.inp[inpIndex],
            value: value,
          };
        }
      }
    },

    handleRemoveCriteria: (state, action) => {
      const { uniqueId } = action.payload;
      const index = state.filterTable.findIndex(
        (item) => item.uniqueId === uniqueId
      );

      if (index !== -1) {
        state.filterTable = state.filterTable.map((item) => {
          if (item.uniqueId === uniqueId) {
            const field =
              item.radioButton === "C"
                ? (item.CFieldName || item.SFieldName)
                : item.radioButton === "CP"
                ? `${item.CFieldName || item.SFieldName}~${item.SFieldName}`
                : item.SFieldName;
            const updatedScreenerQuery = item.customRow === "Custom"
              ? item.screenerQuery
              : `${field}|${item.period || ""}|${item.or || ""}|${item.prox || ""}| |${item.radioButton || "S"}|${(item.DisplayName || "").replace(/'/g, "")}¤`;

            return { ...item, criteria: "", inp: [], screenerQuery: updatedScreenerQuery };
          }
          return item;
        });
      }
    },
  },
});

export const {
  setFilterTable,
  setFilterTableExcel,
  addFilterTableItem,
  removeFilterTableItem,
  clearFilterTable,
  updateFilterTableItem,
  updateFilterChechboxName,
  updateApiFilterTableItem,
  updateAscDescDropdown,
  updateCustomDisplayName,
  updatePopupCriteria,
  handleCancelCriteria,
  updateCriteriaOnClickRadio,
  updateCriteriaOnClickRadioAPI,
  criteriaModelonSave,
  handleRemoveCriteria,
  updateReturnsDay,
} = FilterTableSlice.actions;

export default FilterTableSlice.reducer;
